/**
 * Every IANA zone the runtime knows, so nobody has to type `Europe/Kyiv`
 * correctly. `supportedValuesOf` is recent enough to be worth a fallback:
 * without it the select still offers the stored value and UTC, which is enough
 * to not trap somebody in a zone they cannot change.
 */
export function listTimezones(current: string): string[] {
  const supported =
    typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : [];
  const zones = supported.length > 0 ? supported : ["UTC"];
  return zones.includes(current) ? zones : [current, ...zones];
}
